export const scheduledJobStatus = ['Scheduled', 'Disabled', 'Paused'];
